import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { ReceptionSidebar } from "../Layouts/ReceptionSidebar";

export class CreateBill extends Component {
  constructor(props) {
    super(props);
    const url = "";

    this.state = {
      procedurename: "",

      procedurename: "",
      paymentstype: "",
      paymentsrefcode: "",
      paymentsamount: "",
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlemodalSubmit = this.handlemodalSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handlemodalSubmit(event) {
    // alert(localStorage.getItem('confirmVisitId'))
    event.preventDefault();
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("confirmVisitId"),
    };
    event.preventDefault();
    console.log(localStorage.getItem("accessToken"));
    console.log(this.state);
    axios
      .get(this.api_url+"billing/update/paid", this.state, {
        headers: headers,
      })
      .then((response) => {
        console.log(response);
        if (
          window.confirm("Are you sure you want to confirm patient?") == true
        ) {
          $("#loginSuccess").show();

          $(".modal").hide();
          const headers = {
            "Content-Type": "application/json",
            token: localStorage.getItem("accessToken"),
            visitid: localStorage.getItem("confirmVisitId"),
          };

          console.log(localStorage.getItem("confirmModule"));

          axios
            .get(
              this.api_url+"billing/status/" +
                localStorage.getItem("confirmModule") +
                "/confirm",
              this.state,
              { headers: headers }
            )
            .then((response) => {
              // $(this).hide();
              // $(this).attr('text', "Confirmed");
              alert("Confirmed");
              //   http://localhost:3000
              window.location.href = "/confirm/patient";
              //   window.location.reload()
              $(this).attr("class", "btn btn-success");
              $(this).prop("disabled", true);

              $(".form-control").attr("value", "");

              // $('.confirmedMessage').show()();
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          // text = "You canceled!";
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    var moduleSelected = this.state["module"];
    // console.log(module)
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("confirmVisitId"),
    };

    axios
      .post(this.api_url+"billing/triage/create", this.state, {
        headers: headers,
      })
      .then((res) => {
        //   const verified = res.data;
        console.log(res.data);
        if (res.data["status"]) {
          $("#sendModuleSuccess").show();
          $(".confirmPayment").show();
          axios
            .get(this.api_url+"billing/pendingpayments", { headers: headers })
            .then((res) => {
              const procedurecosts = res.data;
              console.log(Object.keys(procedurecosts));

              Object.keys(procedurecosts).forEach((cost) => {
                if (cost !== "total_paid" && cost !== "total_pending") {
                  var option =
                    "<option value=" + cost + ">" + cost + "</option>";
                  $(".procedureNamePositionmodal").append(option);
                }
              });

              //   this.setState({ procedurecosts });
            });
          //
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  componentDidMount() {
    // alert(localStorage.getItem('confirmVisitId'))
    //     const article = { title: 'React POST Request Example' };
    // axios.post('https://reqres.in/api/articles', article)
    // .then(response => this.setState({ articleId: response.data.id }));
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("confirmVisitId"),
    };

    axios
      .get(this.api_url+"reception/onepatient", { headers: headers })
      .then((res) => {
        //   const verified = res.data;

        localStorage.setItem("currentVisitName", res.data[0]["Name"]);
        localStorage.setItem(
          "currentVisitNationality",
          res.data[0]["Nationality"]
        );
        localStorage.setItem(
          "currentVisitProfession",
          res.data[0]["Profession"]
        );
        localStorage.setItem("currentVisitAge", res.data[0]["Age"]);
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });

    axios
      .get(this.url + "/chief/procedurecosts", { headers: headers })
      .then((res) => {
        const procedurecosts = res.data;
        console.log(procedurecosts);

        procedurecosts.forEach((cost) => {
          var option =
            "<option value=" +
            cost["procedurename"] +
            ">" +
            cost["procedurename"] +
            "</option>";
          $(".procedureNamePosition").append(option);
        });

        //   this.setState({ procedurecosts });
      });
    $(".sendToModule").on("click", function () {
      $(".module_list").show();
    });
  }

  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right" };
    const floatLeft = { float: "left" };
    const displayHidden = { display: "none" };
    let forgotPasswordUrl = "/forgot/password";
    const { module } = this.state;
    const name = localStorage.getItem("currentVisitName");
    const nationality = localStorage.getItem("currentVisitNationality");
    const profession = localStorage.getItem("currentVisitProfession");
    const current_module = localStorage.getItem("confirmModule");

    const { procedurename, paymentstype, paymentsrefcode, paymentsamount } =
      this.state;
    return (
      <div>
        <Headers />
        <ReceptionSidebar />
        <main className="content-container ">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1"></div>

                <div className="col-md-4 p-2">
                  <h2 className="center text-capitalize">
                    Create Bill for {current_module} Module
                  </h2>
                  <div className="card pt-5 pr-5 pl-5 ">
                    Patient Name: {name}
                    <br />
                    Patient Nationality: {nationality}
                    <br />
                    Patient Profession: {profession}
                    <br />
                    <div className="py-1">
                      <h6 className="text-capitalize" style={fontFamilyNunito}>
                        Choose Procedure Costs
                      </h6>
                      <select
                        onChange={this.handleChange}
                        value={procedurename}
                        name="procedurename"
                        className="form-control procedureNamePosition"
                        required
                      >
                        <option selected disabled></option>
                      </select>
                    </div>
                    <div
                      id="sendModuleSuccess"
                      className="alert alert-success"
                      style={displayHidden}
                      role="alert"
                    >
                      <strong>Success! </strong>Details were saved Successfuly.
                    </div>
                    <div className="row">
                      {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                      <div className="col col-6">
                        <button
                          className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                          type="submit"
                          style={floatLeft}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div className="modal confirmPayment" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title patientName"> </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <form id="formId" onSubmit={this.handlemodalSubmit}>
                    <div className="py-1">
                      <h6 className="text-capitalize" style={fontFamilyNunito}>
                        Procedure Name
                      </h6>
                      <input
                        type="te"
                        className="form-control procedureNamePositionmodal"
                        onChange={this.handleChange}
                        value={procedurename}
                        name="procedurename"
                        readOnly
                        required
                      />

                      {/* <option value="lab_procedure">Lab Procedure</option>
                                                    <option value="triage">Triage</option> */}
                    </div>
                    <div className="py-1">
                      <h6 className="text-capitalize" style={fontFamilyNunito}>
                        Payments Type
                      </h6>
                      <select
                        className="form-control"
                        onChange={this.handleChange}
                        value={paymentstype}
                        name="paymentstype"
                        required
                      >
                        <option selected disabled></option>
                        <option value="cash">Cash</option>
                        <option value="Zaad">Zaad</option>
                        <option value="e-Dahab">e-Dahab</option>
                        {/* <option value="triage">Triage</option> */}
                      </select>
                    </div>
                    <div className="py-1">
                      <h6 className="text-capitalize" style={fontFamilyNunito}>
                        Payments Ref Code
                      </h6>
                      <input
                        className="form-control"
                        onChange={this.handleChange}
                        value={paymentsrefcode}
                        name="paymentsrefcode"
                        required
                      />
                    </div>
                    <div className="py-1">
                      <h6 className="text-capitalize" style={fontFamilyNunito}>
                        Payments Amount
                      </h6>
                      <input
                        className="form-control"
                        onChange={this.handleChange}
                        value={paymentsamount}
                        name="paymentsamount"
                        required
                      />
                    </div>

                    <button
                      className="btn btn-success startTreatment"
                      type="submit"
                    >
                      Confirm Payment
                    </button>
                    <div
                      id="loginSuccess"
                      className="alert alert-success"
                      style={displayHidden}
                      role="alert"
                    >
                      <strong>Success! </strong>Patient Confirmed Successfully
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default CreateBill;
